import { Col, Row } from "react-bootstrap";
import profileImg from '../../assets/images/dashboard/profileImg.jpg';
import { useSelector } from "react-redux";
import moment from "moment";

const RecentActivities = ({ type }) => {
    const {loginDetails} = useSelector(state => state.data);
    const {get_uplaoads} = useSelector(state => state.data);
    const {userActivityData} = useSelector(state => state.data);
    const {userDownloadData} = useSelector(state => state.data);

    const findSpentTime = (loginDate, loginTime, logoutTime) => {
        if (logoutTime === "-") return <span>Still logged in</span>;

        const format = "DD-MMM-YYYY HH:mm:ss";

        const login = moment(`${loginDate} ${loginTime}`, format);
        const logout = moment(`${loginDate} ${logoutTime}`, format);

        if (!login.isValid() || !logout.isValid()) return <span>Invalid time</span>;

        const duration = moment.duration(logout.diff(login));

        const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
        const minutes = String(duration.minutes()).padStart(2, '0');
        const seconds = String(duration.seconds()).padStart(2, '0');

        const formattedTime = `${hours}:${minutes}:${seconds}`;

        return <span>{formattedTime}</span>;
    };

    return (
        <Row className="recent-activity-container-row">
            <Col md={12} className="recent-activity-container-col" >
                

                    {type === "sessions" ? (
                        <>{loginDetails.length !== 0 &&
                            <>
                            <div className="recent-activity-container-first-tab-container upload-activity-div">
                            {loginDetails.map((logins, index) => {
                                return <div className='pb-2' key={index}>
                                        <div className="recent-activity-img-div">
                                            <div className="recent-activity-img-wrapper">
                                                <img src={profileImg} alt="Profile" />
                                                <span className="online-dot"></span>
                                            </div>
                                            <div className="recent-activity-session-profile-name-div">
                                                <p>{logins.name}</p>
                                                <span>{logins.company_name}</span>
                                            </div>
                                        </div>

                                        <Row className="recent-activity-session-lls-row">
                                            <Col md={4} className="recent-activity-session-lls-col">
                                                <p>Login</p>
                                                <span>{logins.login_time !== "-" ? moment(logins.login_time, 'HH:mm:ss').format('hh:mm A') : "-"}</span>
                                            </Col>
                                            <Col md={4} className="recent-activity-session-lls-col">
                                                <p>Logout</p>
                                                <span>{logins.logout_time !== "-" ? moment(logins.logout_time, 'HH:mm:ss').format('hh:mm A') : "-"}</span>
                                            </Col>
                                            <Col md={4} className="recent-activity-session-lls-col">
                                                <p>Spent Time</p>
                                                <span>{findSpentTime(logins.login_date, logins.login_time, logins.logout_time)}</span>
                                            </Col>
                                        </Row>
                                </div>
                            })}
                            </div>
                            </>
                        }</>

                    ) : type === "upload" ? (
                        <>
                            <div className="recent-activity-container-first-tab-container upload-activity-div">
                                {get_uplaoads.length !== 0 ? get_uplaoads.slice(0, 10).map((uploads, index) => {
                                    return <div key={index}>
                                        <div className="recent-activity-img-div">
                                            <div className="recent-activity-upload-date-div">
                                                <h5>{moment(uploads.uploaded_date).format("DD")}</h5>
                                                <span>{moment(uploads.uploaded_date).format("ddd")}</span>
                                            </div>
                                            <div className="recent-activity-session-contacts-no-div">
                                                <h6>{moment(uploads.uploaded_date, 'HH:mm:ss').format("hh:ss A")}</h6>
                                                <span><strong>{uploads.username}</strong> uploaded total {uploads.fresh + uploads.repeated} contacts and {uploads.fresh} fresh contacts</span>
                                            </div>
                                        </div>
                                        {get_uplaoads.length > 10 ? index < 9 && <hr /> : <>{index < get_uplaoads.length - 2 && <hr />}</>}
                                    </div>
                                }): 
                                <div>
                                    <div className="recent-activity-img-div">
                                        No data found
                                    </div>
                                </div>} 
                            </div>
                        </>
                    ) : type === "downloads" ? (
                        <>
                            <div className="recent-activity-container-first-tab-container">
                                {userDownloadData.length !== 0 ? userDownloadData.slice(0, 10).map((download, index) => {
                                    return <div key={index}>
                                        <div className="recent-activity-img-div">
                                            <div className="recent-activity-upload-date-div">
                                                <h5>{moment(new Date(download.date)).format("DD")}</h5>
                                                <span>{moment(download.date).format("ddd")}</span>
                                            </div>
                                            <div className="recent-activity-session-contacts-no-div">
                                                <h6>{moment(download.date, 'HH:mm:ss').format("hh:ss A")}</h6>
                                                <span><strong>{download.user_name}</strong> downloaded {download.count} contacts</span>
                                            </div>
                                        </div>
                                        {userDownloadData.length > 10 ? index < 9 && <hr /> : <>{index < userDownloadData.length - 2 && <hr />}</>}
                                    </div>
                                }) : 
                                <div>
                                    <div className="recent-activity-img-div">
                                        No data found
                                    </div>
                                </div>}    
                            </div>
                        </>
                    ) : type === "activities" ? (
                        <>
                            <div className="recent-activity-container-first-tab-container upload-activity-div">
                                {userActivityData.length !== 0 ? userActivityData.slice(0, 10).map((activity, index) => {
                                    return <div key={index}>
                                        <div className="recent-activity-img-div">
                                            <div className="recent-activity-upload-date-div">
                                                <h5>{moment(activity.date, "DD-MMM-YYYY").format("DD")}</h5>
                                                <span>{moment(activity.date, "DD-MMM-YYYY").format("ddd")}</span>
                                            </div>
                                            <div className="recent-activity-session-contacts-no-div">
                                                <h6>{moment(activity.date, "DD-MMM-YYYY").format("MMM/YYYY")}</h6>
                                                <span><strong>{activity.user_name}</strong> downloaded {activity.count} contacts</span>
                                            </div>
                                        </div>
                                        {userActivityData.length > 10 ? index < 9 && <hr /> : <>{index < userActivityData.length - 2 && <hr />}</>}
                                    </div>
                                }) : 
                                <div>
                                    <div className="recent-activity-img-div">
                                        No data found
                                    </div>
                                </div>} 
                            </div>
                        </>
                    ) : null}
            </Col>
        </Row>
    );
};

export default RecentActivities;
